export enum TipoConsolidado {
  Emitido = 1,
  Recibido = 2
}